<template>
  <div>
    <div class="subscription-list">
      <div
        v-for="elem in item.subscriptions"
        :key="elem.id"
        class="subscription-row"
        @click="goToDetail(elem.id)"
      >
        <div class="sub-col col-status">
          <span class="label">Status</span>
          <span class="badge" :class="statusBadgeClass(elem)">{{ elem.formatted_status }}</span>
        </div>
        <div class="sub-col col-date">
          <span class="label">Início</span>
          <span>{{ elem.formatted_start_date }}</span>
        </div>
        <div class="sub-col col-date">
          <span class="label">Cancelamento</span>
          <span :class="elem.canceled_at ? 'text-danger' : ''">{{ elem.formatted_canceled_at }}</span>
        </div>
        <div class="sub-col col-periodo">
          <span class="label">Período</span>
          <span>{{ elem.formatted_current_period_start }} - {{ elem.formatted_current_period_end }}</span>
        </div>
        <div class="sub-col col-plano">
          <span class="label">Plano</span>
          <strong :class="{ 'text-plus': isPlusPlan(elem) }">{{ elem.formatted_plan_frequency }}</strong>
        </div>
        <div class="sub-col col-valor">
          <span class="label">Valor</span>
          <strong :class="{ 'text-plus': isPlusPlan(elem) }">{{ elem.formatted_unit_amount }}</strong>
        </div>
        <div class="d-flex align-items-center gap-2 ms-auto">
          <a
            :href="stripeSubscriptionLink(elem)"
            target="_blank"
            class="btn btn-sm btn-outline-dark"
            @click.stop
          >
            <i class="fa-brands fa-stripe me-1"></i> Ver no Stripe
          </a>
          <router-link
            :to="`${$paths.subscriptions.detail}/${elem.id}`"
            class="btn btn-sm btn-primary"
            @click.native.stop
          >
            <i class="fa-solid fa-eye me-1"></i> Ver detalhes
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "PsiDetailSubscriptions",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    stripeSubscriptionLink(elem) {
      const acctId = process.env.VUE_APP_STRIPE_PLATFORM_ACCOUNT_ID;
      const mid =
        process.env.VUE_APP_ENV === "prod"
          ? "subscriptions"
          : "test/subscriptions";
      return `https://dashboard.stripe.com/${acctId}/${mid}/${elem.subscription_id}`;
    },
    statusBadgeClass(elem) {
      if (
        elem.status === "canceled" &&
        elem.trial_end &&
        this.$moment(elem.trial_end).isAfter(this.$moment())
      ) {
        return "bg-primary";
      }
      if (elem.status === "active" && elem.canceled_at) {
        return "bg-warning text-dark";
      }
      const classes = {
        active: "bg-success",
        trialing: "bg-primary",
        canceled: "bg-danger",
        past_due: "bg-warning text-dark",
        unpaid: "bg-warning text-dark",
        paused: "bg-secondary",
        incomplete: "bg-warning text-dark",
        incomplete_expired: "bg-danger",
      };
      return classes[elem.status] || "bg-secondary";
    },
    goToDetail(id) {
      this.$router.push(`${this.$paths.subscriptions.detail}/${id}`);
    },
    isPlusPlan(elem) {
      return elem.plan?.slug === 'psiapp-mais-pro';
    },
  },
});
</script>

<style scoped>
.subscription-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}

.subscription-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
}

.subscription-row:hover {
  background-color: #f8f9fa;
  border-color: #dee2e6;
}

.sub-col {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-shrink: 0;
}

.sub-col .label {
  font-size: 0.7rem;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.sub-col span:not(.label):not(.badge),
.sub-col strong {
  font-size: 0.875rem;
  color: #495057;
}

/* Fixed column widths for alignment */
.col-status {
  width: 100px;
}

.col-date {
  width: 110px;
  white-space: nowrap;
}

.col-periodo {
  width: 180px;
}

.col-plano {
  width: 140px;
  flex: 1;
}

.col-valor {
  width: 80px;
}

.text-plus {
  color: #2563eb !important;
}
</style>
